module.exports = __webpack_public_path__ + "images/freshbytes-logo.9f2c0c4c070866bf0fd8ca5f8a907a71.png";


//////////////////
// WEBPACK FOOTER
// ./img/freshbytes-logo.png
// module id = 538
// module chunks = 0